module.exports = __webpack_public_path__ + "static/media/multistore.53f306e7.png";